import Image from "next/image";

import { type FragmentOf, readFragment } from "~/lib/graphql";

import * as fragment from "./graphql";
import { Copyright } from "./Copyright";
import { DoNotCrop } from "./DoNotCrop";
import { FitClip } from "./FitClip";

const DEFAULT_WIDTH = 800;
const DEFAULT_HEIGHT = 600;

export function SingleImage(props: {
  record: FragmentOf<typeof fragment.singleImageFragment>;
}) {
  const record = readFragment(fragment.singleImageFragment, props.record);
  const img = record.image;

  if (!img) return null;

  if (record.doNotCropTheImage) {
    return <DoNotCrop image={img} />;
  }

  if (record.fitClip) {
    return <FitClip image={img} />;
  }

  return (
    <div className="relative mx-auto max-w-[780px]">
      <Image
        src={`${img.url}?w=${DEFAULT_WIDTH}&h=${DEFAULT_HEIGHT}&fit=crop&crop=focalpoint&fp-x=${img.focalPoint?.x}&fp-y=${img.focalPoint?.y}&auto=format`}
        width={DEFAULT_WIDTH}
        height={DEFAULT_HEIGHT}
        alt={img.alt || img.title || ""}
        className="h-auto w-full"
      />
      <Copyright text={img.copyright} />
    </div>
  );
}
